import React, { memo, useMemo } from 'react'
import { Box } from 'transfix-ui/core'
import { Maybe } from 'types/graphqlTypes'
import MarketInsightsCard from 'apps/marketplace/components/MarketInsightsCard'
import { TMarketInsightsLocation } from 'apps/marketplace/components/MarketInsightsCard/types'
import { IAwardedLaneFragment } from '../../../graphql/AwardedLaneFragment'

export interface IDataTabContentProps {
  awardedLane?: IAwardedLaneFragment
}

export const LaneDetailsTabContent = memo<IDataTabContentProps>(({ awardedLane }) => {
  const {
    deliveryCity,
    deliveryLocation,
    deliveryStateCode,
    pickupCity,
    pickupLocation,
    pickupStateCode,
  } = awardedLane ?? {}

  const pickupMarketLocation: Maybe<TMarketInsightsLocation> = useMemo(() => {
    if (pickupCity && pickupStateCode) {
      return { city: pickupCity, stateCode: pickupStateCode }
    }

    return pickupLocation
  }, [pickupCity, pickupLocation, pickupStateCode])

  const deliveryMarketLocation: Maybe<TMarketInsightsLocation> = useMemo(() => {
    if (deliveryCity && deliveryStateCode) {
      return { city: deliveryCity, stateCode: deliveryStateCode }
    }

    return deliveryLocation
  }, [deliveryCity, deliveryLocation, deliveryStateCode])

  return (
    <Box mt={3}>
      <MarketInsightsCard
        pickupLocation={pickupMarketLocation}
        deliveryLocation={deliveryMarketLocation}
      />
    </Box>
  )
})

export default LaneDetailsTabContent
